var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncemail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23081 14.625C2.85194 14.625 2.53125 14.4938 2.26875 14.2313C2.00625 13.9688 1.875 13.6481 1.875 13.2692V4.73081C1.875 4.35194 2.00625 4.03125 2.26875 3.76875C2.53125 3.50625 2.85194 3.375 3.23081 3.375H14.7692C15.1481 3.375 15.4688 3.50625 15.7313 3.76875C15.9938 4.03125 16.125 4.35194 16.125 4.73081V13.2692C16.125 13.6481 15.9938 13.9688 15.7313 14.2313C15.4688 14.4938 15.1481 14.625 14.7692 14.625H3.23081ZM9 9.41831L15 5.58169L14.8847 4.5L9 8.25L3.11531 4.5L3 5.58169L9 9.41831Z",
    fill: "#626F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncemail);
export default __webpack_public_path__ + "static/media/announcemail.dbedbce1fb407c998273a5fd6098de26.svg";
export { ForwardRef as ReactComponent };